<app-signup class="login" *ngIf="activeId === 'signup'" (action)="onAction($event)"></app-signup>
<ng-container [ngSwitch]="activeId">
  <ng-template ngSwitchCase="'signup'">1</ng-template>
  <ng-template ngSwitchCase="'signin'">2</ng-template>
</ng-container>
